import { UserPlus, Globe, MessageSquare, TrendingUp } from "lucide-react";

const steps = [
  { number: "01", icon: UserPlus, iconClass: "icon-primary", title: "Créer un compte", description: "Inscris-toi en 30 secondes avec ton email. C'est gratuit et sans carte bancaire." },
  { number: "02", icon: Globe, iconClass: "icon-orange", title: "Choisir ton pays et ta classe", description: "Dis-nous dans quelle classe tu es. L'IA adapte tout son contenu à ton programme scolaire." },
  { number: "03", icon: MessageSquare, iconClass: "icon-green", title: "Discuter avec l'IA", description: "Pose tes questions, demande des explications, envoie tes exercices. L'IA t'aide en temps réel." },
  { number: "04", icon: TrendingUp, iconClass: "icon-yellow", title: "Apprendre et progresser", description: "Gagne des points, monte de niveaux et suis ta progression. Apprendre devient vraiment fun !" },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-16 sm:py-24 bg-muted/40">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-16">
          <div className="badge-new inline-flex mb-4"><span>🗺️</span><span>Simple et intuitif</span></div>
          <h2 className="section-title">Comment ça marche ?</h2>
          <p className="section-subtitle mt-4">Commence à apprendre avec l'IA en 4 étapes simples. Aucune compétence technique requise.</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={step.number} className="card-edu p-6 flex flex-col items-center text-center group">
                <div className="relative mb-5">
                  <div className={`${step.iconClass} transition-transform duration-300 group-hover:scale-110`}>
                    <Icon className="w-7 h-7" />
                  </div>
                  <div className="absolute -top-2 -right-2 w-6 h-6 rounded-full flex items-center justify-center text-xs font-black text-white" style={{ background: "var(--gradient-hero)" }}>
                    {index + 1}
                  </div>
                </div>
                <h3 className="text-lg font-extrabold text-foreground mb-2">{step.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed font-medium">{step.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
